<template>
  <v-container :fluid="isFluid">
    <AllEventsSearchForm :filter-context="filterContext" />

    <v-row justify="start">
      <v-col cols="12">
        <div class="mt-3 app-all-events__showsearch">
          <button @click.prevent="toggleAdvancedSearchForm()">
            <span>Show Advanced Search</span>
            <v-icon
              color="#E44475"
              medium
            >
              {{
                advancedSearchActive ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }}
            </v-icon>
          </button>
        </div>
      </v-col>
    </v-row>

    <AllEventsAdvancedSearchOptions :filter-context="filterContext" />
  </v-container>
</template>

<script>
import AllEventsSearchForm from '@/components/Search/AllEventsSearchForm';
import AllEventsAdvancedSearchOptions from '@/components/Search/AllEventsAdvancedSearchOptions';

export default {
  name: 'AdvancedSearchContainer',

  components: {
    AllEventsSearchForm,
    AllEventsAdvancedSearchOptions
  },

  emits: [
    'toggle-advanced-search-form'
  ],

  props: {
    advancedSearchActive: {
      type: Boolean,
      default: false
    },
    filterContext: {
      type: String,
      default: 'allEvents'
    },
    isFluid: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggleAdvancedSearchForm() {
      this.$emit('toggle-advanced-search-form');
    }
  }
}
</script>
